import { render, staticRenderFns } from "./ExpensesBarChart.vue?vue&type=template&id=69fe4945&scoped=true&lang=pug&"
import script from "./ExpensesBarChart.vue?vue&type=script&setup=true&lang=js&"
export * from "./ExpensesBarChart.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ExpensesBarChart.vue?vue&type=style&index=0&id=69fe4945&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fe4945",
  null
  
)

export default component.exports